var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 2,
    viewBox: "0 0 44 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.68335,
    width: 29.8222,
    height: 2,
    fill: "#1A5298"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4609,
    width: 6.11111,
    height: 2,
    fill: "#1A5298"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5278,
    width: 3.42222,
    height: 2,
    fill: "#1A5298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup29);
export default __webpack_public_path__ + "static/media/Group29.0ddebbe3c58a6f35cb636c96d228b02e.svg";
export { ForwardRef as ReactComponent };